import { WORKOUT_LEVELS } from '../../api/workouts.interface';

export const EXERCISE_LEVEL_OPTIONS = WORKOUT_LEVELS;

export const EXERCISE_PLAN_OPTIONS = [
    'Upper Body',
    'Lower Body',
    'Abs',
    'Full Body',
    'Cardio',
    'Mobility',
    'Warm Up',
];

export const EXERCISE_WEIGHT_OPTIONS = [
    'Bodyweight',
    'Light',
    'Medium',
    'Heavy',
];

export const EXERCISE_MAT_OPTIONS = [
    'Yes',
    'No',
];

export const EXERCISE_BOOTY_BAND_OPTIONS = [
    'None',
    'Light',
    'Medium',
    'Heavy',
];